import { render } from "./PriceView.vue?vue&type=template&id=db998f5e&scoped=true"
import script from "./PriceView.vue?vue&type=script&lang=js"
export * from "./PriceView.vue?vue&type=script&lang=js"

import "./PriceView.vue?vue&type=style&index=0&id=db998f5e&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db998f5e"]])

export default __exports__